import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import './Sidebar.css';

import API_URL from '../../config';


/* Feather-style SVG icons */
const Icons = {
  home: (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"/><polyline points="9 22 9 12 15 12 15 22"/>
    </svg>
  ),
  feed: (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M4 11a9 9 0 0 1 9 9"/><path d="M4 4a16 16 0 0 1 16 16"/><circle cx="5" cy="19" r="1"/>
    </svg>
  ),
  projects: (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M22 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5l2 3h9a2 2 0 0 1 2 2z"/>
    </svg>
  ),
  forum: (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/>
    </svg>
  ),
  messages: (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/><polyline points="22,6 12,13 2,6"/>
    </svg>
  ),
  jobs: (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <rect x="2" y="7" width="20" height="14" rx="2" ry="2"/><path d="M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16"/>
    </svg>
  ),
  templates: (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <rect x="3" y="3" width="7" height="7"/><rect x="14" y="3" width="7" height="7"/><rect x="14" y="14" width="7" height="7"/><rect x="3" y="14" width="7" height="7"/>
    </svg>
  ),
  documents: (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/><line x1="16" y1="13" x2="8" y2="13"/><line x1="16" y1="17" x2="8" y2="17"/><polyline points="10 9 9 9 8 9"/>
    </svg>
  ),
  groups: (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/>
    </svg>
  ),
  warning: (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"/><line x1="12" y1="9" x2="12" y2="13"/><line x1="12" y1="17" x2="12.01" y2="17"/>
    </svg>
  ),
  star: (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/>
    </svg>
  ),
  poll: (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <line x1="18" y1="20" x2="18" y2="10"/><line x1="12" y1="20" x2="12" y2="4"/><line x1="6" y1="20" x2="6" y2="14"/>
    </svg>
  ),
  news: (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M4 22h16a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2H8a2 2 0 0 0-2 2v16a2 2 0 0 1-2 2zm0 0a2 2 0 0 1-2-2v-9c0-1.1.9-2 2-2h2"/><line x1="10" y1="6" x2="18" y2="6"/><line x1="10" y1="10" x2="18" y2="10"/><line x1="10" y1="14" x2="14" y2="14"/>
    </svg>
  ),
  settings: (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="12" cy="12" r="3"/><path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-4 0v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83-2.83l.06-.06A1.65 1.65 0 0 0 4.68 15a1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1 0-4h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 2.83-2.83l.06.06A1.65 1.65 0 0 0 9 4.68a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 2.83l-.06.06A1.65 1.65 0 0 0 19.4 9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1z"/>
    </svg>
  ),
  help: (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="12" cy="12" r="10"/><path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3"/><line x1="12" y1="17" x2="12.01" y2="17"/>
    </svg>
  ),
  logout: (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"/><polyline points="16 17 21 12 16 7"/><line x1="21" y1="12" x2="9" y2="12"/>
    </svg>
  ),
};

const navItems = [
  { id: 'home',     icon: Icons.home,     label: 'Ana Sayfa',    path: '/dashboard' },
  { id: 'projects', icon: Icons.projects, label: 'Projelerim',   path: '/projects' },
  { id: 'messages', icon: Icons.messages, label: 'Mesajlar',     path: '/messages' },
];

const sectionItems = [
  { id: 'feed_regulation',       icon: Icons.documents, label: 'Mevzuat',       path: '/regulations' },
  { id: 'feed_field_warning',    icon: Icons.warning,   label: 'Uyarılar',      path: '/warnings' },
  { id: 'feed_product_review',   icon: Icons.star,      label: 'İncelemeler',   path: '/reviews' },
  { id: 'feed_poll',             icon: Icons.poll,      label: 'Anketler',      path: '/polls' },
  { id: 'feed_document',         icon: Icons.documents, label: 'Dokümanlar',    path: '/documents' },
  { id: 'feed_news',             icon: Icons.news,      label: 'Haberler',      path: '/news' },
  { id: 'feed_job',              icon: Icons.jobs,      label: 'İş İlanları',   path: '/jobs' },
  { id: 'feed_template',         icon: Icons.templates, label: 'Şablonlar',     path: '/templates' },
];

const Sidebar = ({ activeId, user, onLogout, className = '' }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [storage, setStorage] = useState(null);

  useEffect(() => {
    if (!user) return;
    const fetchStorage = () => {
      const token = localStorage.getItem('projabze_token');
      if (!token) return;
      fetch(`${API_URL}/api/projects/storage`, { headers: { Authorization: `Bearer ${token}` } })
        .then(r => r.ok ? r.json() : null)
        .then(d => { if (d) setStorage(d); })
        .catch(() => {});
    };
    fetchStorage();
    window.addEventListener('projabze-storage-updated', fetchStorage);
    return () => window.removeEventListener('projabze-storage-updated', fetchStorage);
  }, [user]);

  if (!user) return null;

  // Detect active section item from current path
  const activeSectionId = sectionItems.find(item => item.path === location.pathname)?.id || null;

  const initials = (user.firstName?.[0] || '') + (user.lastName?.[0] || '');

  return (
    <aside className={`app-sidebar ${className}`.trim()}>
      <div className="app-sidebar-top">
        <div className="app-sidebar-card" onClick={() => navigate(`/profile/${user.id}`)}>
          <div className="app-sidebar-card-avatar">
            {user.avatar ? <img src={API_URL + user.avatar} alt="" /> : initials}
          </div>
          <div className="app-sidebar-card-info">
            <span className="app-sidebar-card-name">{user.firstName} {user.lastName}</span>
            <span className="app-sidebar-card-email">{user.email}</span>
          </div>
        </div>
        {storage && (
          <div className="app-sidebar-quota">
            <div className="app-sidebar-quota-row">
              <span className="app-sidebar-quota-label">Depolama</span>
              <span className="app-sidebar-quota-value">
                {storage.usedGB < 0.01 ? `${Math.round(storage.usedBytes / 1024 / 1024)} MB` : `${storage.usedGB} GB`} / {storage.maxGB} GB
              </span>
            </div>
            <div className="app-sidebar-quota-bar">
              <div
                className={`app-sidebar-quota-fill${storage.percent >= 90 ? ' danger' : storage.percent >= 70 ? ' warn' : ''}`}
                style={{ width: `${storage.percent}%` }}
              />
            </div>
            <div className="app-sidebar-quota-row">
              <span className="app-sidebar-quota-label">Projeler</span>
              <span className="app-sidebar-quota-value">
                {storage.projectCount} / {storage.maxProjects === -1 ? '∞' : storage.maxProjects}
              </span>
            </div>
          </div>
        )}
        <nav className="app-sidebar-nav">
          {navItems.map(item => (
            <button
              key={item.id}
              className={`app-sidebar-item ${activeId === item.id ? 'active' : ''}`}
              onClick={() => navigate(item.path)}
            >
              <span className="app-sidebar-icon">{item.icon}</span>
              <span>{item.label}</span>
            </button>
          ))}
          <div className="app-sidebar-divider" />
          <span className="app-sidebar-section-title">DAHA FAZLASI</span>
          {sectionItems.map(item => (
            <button
              key={item.id}
              className={`app-sidebar-item app-sidebar-item-sm ${activeSectionId === item.id ? 'active' : ''}`}
              onClick={() => navigate(item.path)}
            >
              <span className="app-sidebar-icon">{item.icon}</span>
              <span>{item.label}</span>
            </button>
          ))}
        </nav>
      </div>
      <div className="app-sidebar-bottom">
        <div className="app-sidebar-quick-links">
          <span className="app-sidebar-quick-title">Hızlı Linkler</span>
          <a onClick={() => window.open('/app', 'projabze-editor')}>Çizim Editörü</a>
          <a onClick={() => navigate('/dashboard')}>Ana Sayfa</a>
          <a onClick={() => navigate('/feed')}>Ağ</a>
          <a onClick={() => navigate('/messages')}>Mesajlar</a>
          <a onClick={() => navigate('/explore')}>Keşfet</a>
        </div>
      </div>
    </aside>
  );
};

export default Sidebar;
